<div class="page-list-container">
    <!-- Header -->
    <div class="page-list-header">
        <h1 class="page-title">{{ pageTitle }}</h1>
        <div class="stats-row" *ngIf="stats.length || totalValue !== null || hasStatSlot">
            <span class="stat-total"><strong>{{ totalValue }}</strong> {{ totalLabel }}</span>
            <ng-container *ngFor="let stat of stats">
                <span class="stat-divider">•</span>
                <span class="stat" [style.color]="stat.color || '#6b7280'">
                    <span class="stat-dot" *ngIf="stat.dotClass" [ngClass]="stat.dotClass"></span>
                    {{ stat.value }} {{ stat.label }}
                </span>
            </ng-container>
            <ng-content select="[stat-slot]"></ng-content>
        </div>
    </div>

    <!-- Toolbar -->
    <div class="toolbar">
        <div class="search-container">
            <img src="assets/icons/search-icon.svg" alt="search" class="search-icon">
            <input type="text" class="search-input" [placeholder]="searchPlaceholder"
                [ngModel]="searchTerm" (ngModelChange)="onSearchInput($event)">
        </div>
        <div class="tabs-container" *ngIf="showTabs && tabs.length">
            <button class="tab" *ngFor="let tab of tabs" [class.active]="activeTab === tab.key"
                (click)="selectTab(tab.key)">
                {{ tab.label }}
            </button>
        </div>
        <div class="toolbar-actions" *ngIf="hasToolbarActions">
            <ng-content select="[toolbar-actions]"></ng-content>
        </div>
    </div>

    <!-- Body / Projected Content -->
    <div class="page-list-body">
        <ng-content></ng-content>
    </div>
</div>
